module.exports = __webpack_public_path__ + "img/right_answer_icon.3afdb761.svg";